import type { CaseTimelineEntry } from '@/types';
import { formatDate } from './shared';

/* ─── Case Timeline Tab ─── */

export function CaseTimelineTab({ timeline }: { timeline: CaseTimelineEntry[] }) {
    if (timeline.length === 0) {
        return <p className="py-8 text-center text-[13px] text-[#999]">No timeline entries found.</p>;
    }

    return (
        <div className="rounded-xl border border-[#eee] p-5">
            <h3 className="mb-4 text-[14px] font-bold text-secondary">Case Timeline</h3>

            <div className="relative">
                <div className="absolute bottom-2 left-1.75 top-2 w-0.5 bg-[#eee]" />

                <div className="space-y-6">
                    {timeline.map((item) => (
                        <div key={item.id} className="relative pl-7">
                            <div className="absolute left-0 top-1 h-4 w-4 rounded-full border-2 border-white bg-primary" />

                            <div className="rounded-xl border border-[#eee] p-4">
                                <div className="flex items-start justify-between gap-3">
                                    <h4 className="text-[13px] font-bold text-secondary">{item.title}</h4>
                                    <span className="shrink-0 text-[11px] text-[#888]">
                                        {formatDate(item.createdAt)}
                                    </span>
                                </div>
                                <p className="mt-2 text-[12px] leading-relaxed text-[#555]">{item.detail}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
